import type { ReactNode } from "react";

const SHELL_STYLES = {
  default:
    "rounded-2xl border border-zinc-200/80 bg-white/95 p-3.5 shadow-[0_14px_40px_-12px_rgba(15,23,42,0.18),0_6px_16px_-8px_rgba(15,23,42,0.1)] backdrop-blur-sm xl:p-4",
  minimal:
    "rounded-3xl border border-zinc-100 bg-white px-5 py-5 shadow-[0_10px_36px_-18px_rgba(15,23,42,0.12)] sm:px-6 sm:py-6",
} as const;

const TITLE_STYLES = {
  default: "text-[11px] font-medium tracking-wide text-zinc-500 xl:text-xs",
  minimal: "text-xs text-zinc-400",
} as const;

export function DashboardStatCardShell({
  title,
  children,
  className = "",
  variant = "compact",
  tone = "default",
  align = "left",
  decorative = false,
}: {
  title: string;
  children: ReactNode;
  className?: string;
  variant?: "compact" | "fluid";
  tone?: keyof typeof SHELL_STYLES;
  align?: "left" | "center";
  decorative?: boolean;
}) {
  const widthClass = variant === "fluid" ? "w-full" : "w-[168px] xl:w-[200px]";
  const alignClass = align === "center" ? "text-center" : "";

  return (
    <div
      aria-hidden={decorative || undefined}
      className={`${widthClass} ${SHELL_STYLES[tone]} ${alignClass} ${className}`}
      style={tone === "default" ? { filter: "drop-shadow(0 10px 24px rgba(15, 23, 42, 0.08))" } : undefined}
    >
      <p className={TITLE_STYLES[tone]}>{title}</p>
      {children}
    </div>
  );
}
